import { createAction } from "actions/createAction";
import { RAW_PACKETS_SET_FILTERS } from "const/actionTypes";
import { AnyAction } from "@reduxjs/toolkit";
import { formatLocalDateNoMs } from "utils";
import { toBackendUTCString, lastMinutesToEndOfDayUTC } from "utils/time";

export interface RawPacketItem {
    call_id: string;
    time: string;
    number_from: string;
    number_to: string;
    ip_src: string;
    ip_dst: string;
    method_code: string;
};

export interface RawPacketsState {
    filters: {
        [key: string]: any;
    };
};

export interface RawPacketGroupItem {
    call_id: string;
    time: string;
    number_from: string;
    number_to: string;
    ip_src: string;
    ip_dst: string;
    method_code: string;
};

// Initial state
const { from, to } = lastMinutesToEndOfDayUTC(5);

const initialState: RawPacketsState = {
    filters: {
        time_from: toBackendUTCString(from),
        time_to: toBackendUTCString(to),
        ip_src: "",
        ip_dst: "",
        call_id: "",
        method_code: ""
    }
};


const handlers = {
    [RAW_PACKETS_SET_FILTERS]: (state: RawPacketsState, action: AnyAction) => ({
        ...state,
        filters: {
            ...state.filters,
            ...action.payload
        }
    }),
    DEFAULT: (state: RawPacketsState) => state
} as const;

// Reducer
const rawPacketsReducer = (state = initialState, action: AnyAction) => {
    const handle = handlers[action.type as keyof typeof handlers] || handlers.DEFAULT;
    return handle(state, action as any);
};

export default rawPacketsReducer; 